module.exports = __webpack_public_path__ + "static/brick-shapey-cef852b58e527276b3644d433a089347.gif";